import {
    getVariableGroupI18nKey,
    GROUP_ORDER_BOOK,
    GROUP_ORDER_PRESS,
    resolveTemplateVariableGroup,
    type AgreementVariableGroupId,
} from "components/ContractsSettings/ContractEditorLexical/groupTemplateVariables";
import type { ICustomField } from "store/customFieldsStore";
import type { TPortalType } from "store/types";
import { EPortalType } from "store/types";

import type { FoundVariable } from "./VariablesList";

export type { AgreementVariableGroupId };
export { getVariableGroupI18nKey };

export type AgreementVariableGroup = {
    id: AgreementVariableGroupId;
    variables: FoundVariable[];
};

export const groupAgreementVariables = (
    variables: FoundVariable[],
    portalType: TPortalType,
    customFields: ICustomField[],
): AgreementVariableGroup[] => {
    const customFieldByUuid = new Map(customFields.map((field) => [field.uuid, field]));
    const groupsById = new Map<AgreementVariableGroupId, FoundVariable[]>();
    const order = portalType === EPortalType.BOOK ? GROUP_ORDER_BOOK : GROUP_ORDER_PRESS;

    for (const variable of variables) {
        const groupId = resolveTemplateVariableGroup(variable.name, portalType, customFieldByUuid);
        const groupVariables = groupsById.get(groupId) ?? [];
        groupVariables.push(variable);
        groupsById.set(groupId, groupVariables);
    }

    return order
        .map((groupId) => ({ id: groupId, variables: groupsById.get(groupId) ?? [] }))
        .filter((group) => group.variables.length > 0);
};
